/**
 * Conexión Socket.IO para notificaciones en tiempo real.
 * Envía el access_token en auth.token; el backend lo verifica con el mismo
 * contrato que passport-jwt ({ sub, type }) y une el socket a la sala del
 * usuario. El evento 'new_notification' es solo un disparador: el handler
 * re-consulta la notificación más reciente para reutilizar la línea base.
 */
import { io, Socket } from 'socket.io-client';
import { getItem } from '../utils/localStorageControl';

const API_ENDPOINT = (process.env.REACT_APP_API_ENDPOINT || '').replace(/\/+$/, '');

let socket: Socket | null = null;

export const connectNotificationsSocket = (onNewNotification: () => void): Socket | null => {
  if (!API_ENDPOINT) {
    console.warn('REACT_APP_API_ENDPOINT no definido; socket de notificaciones deshabilitado');
    return null;
  }

  if (socket) {
    // Renovar credenciales por si el token se refrescó desde la última conexión
    socket.auth = { token: getItem('access_token') };
    if (!socket.connected) {
      socket.connect();
    }
    return socket;
  }

  socket = io(API_ENDPOINT, {
    auth: { token: getItem('access_token') },
  });

  socket.on('new_notification', () => onNewNotification());
  socket.on('connect_error', (err: Error) => {
    console.warn('Socket connect error:', err.message);
  });

  return socket;
};

export const disconnectNotificationsSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
